// extracted by mini-css-extract-plugin
export var active = "_2e-9";
export var backButton = "_2e-8";
export var clone = "_2e-e";
export var collapseBar = "_2e-j";
export var collapseMode = "_2e-l";
export var collapsed = "_2e-n";
export var dragHandle = "_2e-c";
export var dropdownIcon = "_2e-g";
export var expanding = "_2e-m";
export var hidden = "_2e-w";
export var iconContainer = "_2e-p";
export var iconSwapper = "_2e-v";
export var navItem = "_2e-6";
export var navItemIcon = "_2e-f";
export var navProfile = "_2e-7";
export var notificationCountBadge = "_2e-i";
export var notificationDot = "_2e-q";
export var optionsContainer = "_2e-h";
export var primaryNav = "_2e-0";
export var primaryNavDivider = "_2e-u";
export var primaryNavResizeHandle = "_2e-2";
export var primaryNavResizing = "_2e-1";
export var primaryNavTabSection = "_2e-t";
export var primaryTab = "_2e-o";
export var primaryTabIconBox = "_2e-r";
export var secondaryNav = "_2e-3";
export var selected = "_2e-s";
export var settingsNav = "_2e-4";
export var settingsNavItems = "_2e-5";
export var show = "_2e-d";
export var sideNav = "_2e-k";
export var teamItem = "_2e-a";
export var userProfileItem = "_2e-b";